const EXCLUDED_PLAN_NAMES = ['tp paschoalotto']

export const isTotalPassAppointment = (schedule: any): boolean => {
  const planName: string = (schedule?.plan_name || '').toLowerCase()

  if (!planName || !schedule?.plan_associate_id) return false

  const isExcluded = EXCLUDED_PLAN_NAMES.some((excludedName) =>
    planName.includes(excludedName)
  )

  if (isExcluded) return false

  return planName.includes('tp') || planName.includes('totalpass')
}
